import { render } from "./WorkspaceUsers.vue?vue&type=template&id=7fb6169e"
import script from "./WorkspaceUsers.vue?vue&type=script&lang=js"
export * from "./WorkspaceUsers.vue?vue&type=script&lang=js"

import "./WorkspaceUsers.vue?vue&type=style&index=0&id=7fb6169e&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__